var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8,
    r: 6.5,
    transform: "rotate(-180 8.5 8)",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11V7M8.5 6V5",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOC41IiBjeT0iOCIgcj0iNi41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDguNSA4KSIgc3Ryb2tlPSIjN0Q4MDg1IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8cGF0aCBkPSJNOC41IDExTDguNSA3IiBzdHJva2U9IiM3RDgwODUiIHN0cm9rZS13aWR0aD0iMS4yIi8+CjxwYXRoIGQ9Ik04LjUgNkw4LjUgNSIgc3Ryb2tlPSIjN0Q4MDg1IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8L3N2Zz4K";
export { SvgIconWarn as ReactComponent };